import { typeConfig } from "./typeConfig";

export const useTypeConfig = () => {
  const type = localStorage.getItem("type") || "service_sector";
  return typeConfig[type];
};